import React from 'react';
import './DisplayScreen.css';
import CountdownTimer from './CountdownTimer';

export const DisplayScreen = ({ title, paragraph, lowerText, animationEnabled, timerEnabled, targetTime, targetTimezone, timerLabel, manualMode, manualCurrentTime, backgroundUrl, onTimerZero }) => {
  return (
    <div
      className="display-screen"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${backgroundUrl || '/zoom-background-2.png'})` }}
    >
      {/* Animated Background */}
      <div className="screen-background">
        <div className="gradient-overlay" />
        <div className="grid-pattern" />
        {animationEnabled && (
          <>
            <div className="particles-container">
              {[...Array(20)].map((_, i) => (
                <div key={i} className="particle" style={{
                  left: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 10}s`,
                  animationDuration: `${15 + Math.random() * 10}s`
                }} />
              ))}
            </div>
            <div className="light-sweep" />
            <div className="light-sweep-2" />
          </>
        )}
      </div>

      {/* Content Layer */}
      <div className="content-layer">
        {/* Spacer for logo area in background image */}
        <div className="logo-spacer" />

        {/* Center Content */}
        <div className="center-content">
          <div className="glass-panel main-panel">
            <h1 className="main-title">{title}</h1>
          </div>

          {paragraph && (
            <div className="glass-panel paragraph-panel">
              <p className="paragraph-text">{paragraph}</p>
            </div>
          )}

          {timerEnabled && (
            <CountdownTimer
              targetTime={targetTime}
              targetTimezone={targetTimezone}
              label={timerLabel}
              manualMode={manualMode}
              manualCurrentTime={manualCurrentTime}
              onZero={onTimerZero}
            />
          )}
        </div>

        {/* Lower Third */}
        {lowerText && (
          <div className="lower-third">
            <div className="glass-panel lower-panel">
              <p className="lower-text">{lowerText}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayScreen;